/**
 * Flattens nested react-hook-form data structure for tech filter values.
 * Converts { techValueId: { min: 10, max: 20 } } to { "techValueId.min": 10, "techValueId.max": 20 }
 */
export function flattenTechFilterFormData(
  formData: Record<string, { min?: number | undefined; max?: number | undefined }>,
): Record<string, number | undefined> {
  const flattened: Record<string, number | undefined> = {};

  for (const key in formData) {
    const value = formData[key];

    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      // This is a nested object, flatten it
      for (const nestedKey of ["min", "max"] as const) {
        if (value[nestedKey] !== undefined && value[nestedKey] !== null) {
          flattened[`${key}.${nestedKey}`] = value[nestedKey];
        }
      }
    }
  }

  return flattened;
}

/**
 * Unflattens flat tech filter values for react-hook-form.
 * Converts { "techValueId.min": 10, "techValueId.max": 20 } to { techValueId: { min: 10, max: 20 } }
 */
export function unflattenTechFilterFormData(
  flatData: Record<string, number | undefined>,
): Record<string, { min?: number | undefined; max?: number | undefined }> {
  const unflattened: Record<string, { min?: number | undefined; max?: number | undefined }> = {};

  for (const key in flatData) {
    const value = flatData[key];

    if (key.includes(".")) {
      // This is a dotted key, unflatten it
      const [mainKey, subKey] = key.split(".");
      if (!unflattened[mainKey]) {
        unflattened[mainKey] = {};
      }
      unflattened[mainKey][subKey as "min" | "max"] = value;
    }
  }

  return unflattened;
}
